import {includesAnyOf} from '@helpers/common/string.mjs';
import {processValue} from '@components/product/global/tabs/TabHelpers';

export function SingleProductFocusTabs1Description({
  tabDescriptionBodyValue,
  tabDescriptionTableValue
}) {
  // console.log({Tabs1Description: {tabDescriptionBodyValue, tabDescriptionTableValue}})

  if (!tabDescriptionBodyValue) {
    return null;
  }
  let sections = tabDescriptionBodyValue?.split('\n');
  sections = sections
    ?.map((productRow) => {
      return String(productRow)?.trim();
    })
    ?.filter(Boolean);

  const isTableExistsEmpty = (obj) => {
    if (obj?.tableExists && typeof obj?.tableExists === 'object') {
      return Object.keys(obj.tableExists)?.length === 0;
    }
    return false;
  };

  // Dynamically insert DescriptionTable somewhere here after 2nd paragraph always
  const tableExists = isTableExistsEmpty(tabDescriptionTableValue);
  if (tableExists) {
    const tableContent = <DescriptionTable key={2} value={tabDescriptionTableValue} />;
    sections.splice(1, 0, [tableContent]);
  }

  return (
    <div className='text-sm lg:text-base'>
      {sections?.map((productRow, index) => (
        <div key={index} className={'mb-2 last:mb-0'}>
          {productRow}
        </div>
      ))}
    </div>
  );
}

function DescriptionTable({value}) {
  if (!value) {
    return null;
  }
  const json = typeof value === 'string' ? JSON.parse(value) : value;
  let quickFacts = Object.keys(json);
  // move these keys on top
  const keyIncludesSortOnTop = ['Model', 'Included'];
  quickFacts.sort((a, b) => (includesAnyOf(a, keyIncludesSortOnTop) ? -1 : 0));

  return (
    <div className={'pt-2 pb-1 bg-gray-100 rounded border border-neutral-700'}>
      <div
        className={
          'font-oswald tracking-widest uppercase border-b pb-1 border-neutral-700 text-sm px-4'
        }>
        Quick Facts
      </div>

      <div>
        <dl className='divide-y divide-neutral-300 text-sm'>
          {quickFacts?.map((key) => {
            const title = key;
            const html = processValue(json[key]);

            return (
              <div
                key={key}
                className='grid grid-cols-1 gap-1 odd:bg-gray-200 py-2 px-4 sm:grid-cols-2 lg:grid-cols-3 sm:gap-4 text-black'>
                <dt className='font-medium '>{title}</dt>
                <dd className='lg:col-span-2'>{html}</dd>
              </div>
            );
          })}
        </dl>
      </div>
    </div>
  );
}
